import React from "react"
import { Link } from "react-router-dom"
import "styles/pages/notfound.scss"

const NotFound = () => (
  <section className="not-found">
    <h1 className="title">
      Oh snap, We can't find the page you are looking for!
    </h1>
    <p className="subtitle">
      It's either the link is broken or we are experiencing problems.
    </p>
    <Link className="link" to="/">
      Go to school dashboard
    </Link>
  </section>
)

export default NotFound
